export enum CompactModeLevel {
  /** The components that are on the same row and have <= 4 cols are kept on the same row */
  HalfRow = 'HalfRow',
  /** No matter how small an input is - make it expand to full-width */
  FullRow = 'FullRow',
}
